import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { FencyProvider } from "@fencyai/react";
import { useTranslation } from "react-i18next";
import { ExploreMemoriesChat } from "../../../common/fency/ExploreMemoriesChat";
import { fencyPromise } from "../../../common/fency/fencySetup";
import { useFency } from "../../../common/fency/useFency";
import { Layout } from "../../../common/layout/Layout";
import { CONTENT_WIDTH } from "../../../config";

const ContractSearchV2Inner = () => {
  const { t } = useTranslation();
  const { fetchCreateExploreMemoriesClientToken, fetchFencyFileDownloadClientToken } = useFency();

  return (
    <Flex direction="column" h="100%" minH={0} p="6" gap="4">
      <Text fontSize="xl" fontWeight="semibold">
        {t("Search in contracts")}
      </Text>

      <Flex flex={1} minH={0} overflow="hidden">
        <ExploreMemoriesChat
          fetchCreateExploreMemoriesClientToken={fetchCreateExploreMemoriesClientToken}
          fetchFencyFileDownloadClientToken={fetchFencyFileDownloadClientToken}
        />
      </Flex>
    </Flex>
  );
};

export const ContractSearchV2 = () => {
  const { fetchCreateStreamClientToken } = useFency();

  return (
    <Layout showFooter={false}>
      <Grid
        h="calc(100vh - 201px)"
        overflow="hidden"
        gridTemplateColumns={`1fr minmax(0, ${CONTENT_WIDTH}) 1fr`}
        gridTemplateRows="1fr"
        templateAreas={`"leftContent content rightContent"`}
      >
        <GridItem area="content" px="2" minH={0} overflow="hidden">
          <FencyProvider fency={fencyPromise} fetchCreateStreamClientToken={fetchCreateStreamClientToken}>
            <ContractSearchV2Inner />
          </FencyProvider>
        </GridItem>
      </Grid>
    </Layout>
  );
};
